module.exports = __webpack_public_path__ + "media/bgm.8fd85bdf.mp3";